// Shared reorder helpers for the ordered care-plan tabs (Assessed Needs, Goals).

/** Sort a copy of `rows` by `sequence` (missing treated as 0). */
export const bySequence = <Type extends { sequence?: number | null }>(rows: Type[]): Type[] =>
  [...rows].sort((first, second) => (first.sequence ?? 0) - (second.sequence ?? 0));

/** Move `sourceId` to `targetId`'s position; unchanged if either is absent. */
export const reorderByDrop = (order: string[], sourceId: string, targetId: string): string[] => {
  const from = order.indexOf(sourceId);
  const to = order.indexOf(targetId);
  if (from === -1 || to === -1) return order;
  const next = [...order];
  next.splice(from, 1);
  next.splice(to, 0, sourceId);
  return next;
};
